/* 
 * File: src/client/updateNotification/UpdateNotification.jsx
 * Descrizione: Componente che mostra la notifica di aggiornamento.
 * Viene renderizzato tramite React Portal in un nodo separato definito in index.html.
 */

import React, { useContext } from 'react';
import { createPortal } from 'react-dom';
import { UpdateNotificationContext } from './UpdateProvider';
import { updateMessage } from './UpdateContent';
import { Download } from 'lucide-react';

const updateNotificationRoot = document.getElementById('update-notification-root');

const UpdateNotification = () => {
  const { updateAvailable, handleUpdate } = useContext(UpdateNotificationContext);

  if (!updateAvailable) return null;

  const notification = (
    <div className="fixed inset-0 isolate pointer-events-none" style={{ zIndex: 10000 }}>
      <div className="fixed top-4 w-full px-4 sm:px-0 sm:right-4 sm:w-auto flex flex-col items-center sm:items-end">
        <div className="pointer-events-auto w-full sm:w-[420px] animate-fade-in">
          <div className="w-full bg-light-surface-bright dark:bg-dark-surface-bright text-light-on-surface dark:text-dark-on-surface rounded-lg shadow-surface-container">
            <div className="flex items-start gap-3 p-4">
              <div className="flex-shrink-0 mt-0.5">
                <Download className="w-5 h-5" />
              </div>
              
              <div className="flex-1 min-w-0">
                <p className="text-sm break-words">
                  {updateMessage}
                </p>
                <div className="flex gap-3 mt-4">
                  <button
                    onClick={handleUpdate}
                    className="px-4 py-2 bg-light-primary text-light-on-primary dark:bg-dark-primary dark:text-dark-on-primary rounded-md hover:opacity-90 transition-opacity font-medium"
                  >
                    Aggiorna ora
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(notification, updateNotificationRoot);
};

export default UpdateNotification;
